// Transaction Actions constants
export const ACTIONS = {
    SET_DIGIO_FLOW: "SET_DIGIO_FLOW",
    SET_PAYMENT_CHOICE: "SET_PAYMENT_CHOICE",
    SET_COMPLETED: "SET_COMPLETED",
    SET_FAILED: "SET_FAILED",
    SET_ERROR: "SET_ERROR",
    RESET: "RESET",
} as const;

// Action creators
export const setDigioFlow = (orderId: string) => ({
    type: ACTIONS.SET_DIGIO_FLOW,
    payload: { orderId, paymentType: null },
});

export const setPaymentChoice = (isin: string) => ({
    type: ACTIONS.SET_PAYMENT_CHOICE,
    payload: { isin },
});
export const setCompleted = () => ({ type: ACTIONS.SET_COMPLETED });
export const setFailed = (error: string) => ({
    type: ACTIONS.SET_FAILED,
    payload: { error },
});
export const resetTransaction = () => ({ type: ACTIONS.RESET });
